export const errorHelper = (error: any) =>
  error?.response?.data?.message || error.message || error.toString();